import React from "react";
import "./two-column-text-section.m.css";

const TwoColumnTextSection = () => {
  const testimonials = [
    {
      quote: "IMA’s CEO Forum sparks dynamic conversations within peers that expand viewpoints and inspire forward-thinking strategies.",
      name: "Amit Gainda",
      position: "Director and CEO",
      company: "Avanse Financial Services"
    },
    {
      quote: "What I value most is that it  gives me the opportunity to share, interact and learn perspectives from diverse industries and backgrounds.  It helps in challenging the way you see opportunities and challenges from your specific Industry.",
      name: "Prakash Raman",
      position: "Managing Director",
      company: "Silox India"
    }
  ];

  return (
    <div styleName="two-column-text-section">
      <div styleName="testimonial-container">
        {testimonials.map((testimonial, index) => (
          <div key={index} styleName="testimonial-card">
            <div styleName="quote-container">
            <p styleName="quote">“{testimonial.quote}”</p>
            </div>
            <div styleName="author-info">
              <div styleName="author-name">
                {testimonial.name}
              </div>
              <div styleName="author-details">
                <span styleName="position">{testimonial.position}</span>
                <span styleName="divider">|</span>
                <span styleName="company">{testimonial.company}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export { TwoColumnTextSection };